import React from "react";
import styles from "./Terms.module.css";

const Terms = () => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className={styles.termsContainer}>
      <h1 className={styles.heading}>Terms of Use</h1>
      <p className={styles.date}>Last updated: {currentDate}</p>

      <p>
        Welcome to <strong>ImageResizerAndCompressor</strong>. By accessing or
        using our website and service (the "Service"), you agree to comply with
        these terms of use. If you do not agree with any part of these terms,
        please do not use our Service.
      </p>

      <h2>1. Using Our Service</h2>
      <p>
        Our tools allow you to compress, resize, and convert images to popular
        formats such as PNG, JPG, and WebP. You agree you will use the Service
        responsibly and comply with applicable laws.
      </p>

      <h2>2. Image Ownership/Privacy</h2>
      <p>
        You fully own any and all images, you upload. We do not store, share, or
        use your images beyond temporary processing, of compression or
        converting a file. You agree we are not liable for any damages caused by
        your use or inability to use the Service.
      </p>

      <h2>3. No Restricted Use</h2>
      <p>You may not use the Service to:</p>
      <ul>
        <li>
          Upload or process any illegal, obscene or copyrighted material without
          permission
        </li>
        <li>
          Disrupt, hack or interfere with the Service or the Service's servers
        </li>
        <li>Attempt unauthorized access to any part of the website.</li>
      </ul>

      <h2>4. Intellectual Property</h2>
      <p>
        The content, features, and functionality provided on this website are
        owned by <strong>ImageResizerAndCompressor</strong> and are protected by
        copyright law. You may not copy, reproduce, or distribute any portion of
        the Service without prior written consent.
      </p>

      <h2>5. Third-Party Services and Ads</h2>
      <p>
        Our site may contain ads or use third parties' services, including{" "}
        <strong>Google AdSense</strong>. These third parties may collect
        information in compliance with their own privacy policies in an
        anonymous manner.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        The Service is provided <strong>"as is"</strong> and{" "}
        <strong>"as available."</strong> We disclaim any warranties to ensure
        uninterrupted access to the service and no errors. We shall have no
        liability to you for damages incurred as a result of your use, or
        inability to use, the Service.
      </p>

      <h2>7. Change of Policy</h2>
      <p>
        We may change these Terms from time to time to reflect changes in our
        service or legal changes. If you continue to use the Service after a
        change, you agree to the new Terms.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        Please contact us at:{" "}
        <strong>your-imageimagecompressor123@gmail.com</strong> for any
        questions or concerns about these Terms of Use.
      </p>
    </div>
  );
};

export default Terms;
